import React, { Component } from "react";
import Image from '../global/Image';

export default class PageImage extends Component {
  	
	render() {
		
		const block = this.props.block; 
		
		return (
			
			<div id={block.id} className={'c-page__block c-page__block--max-width c-page__block--space-' + block.space + ' c-page__block--load-effect'}>
			 
				<div className="l-grid">
				
					<div className="l-grid__col">
						
						{block.src &&
							
							<div className={'c-image c-image--' + block.alignment}>
									
								<Image width={block.width} height={block.height} srcset={block.srcset} src={block.src} />
														
							</div>
						
						}
						
					</div>
				
				</div>
				
			</div>
			
		)
		
	}
							
}